module.exports = __webpack_public_path__ + "assets/resstar4-0at2x.7ff52f48661e503b6cec9359e2c86410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/stars/resstar4-0at2x.png
// module id = 858
// module chunks = 0